import { businessQuotesService } from '@/services/quotes/business';
import { homeownerQuotesService } from '@/services/quotes/homeowner';
import type { GetProposalPdfResponse } from '@/services/quotes/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  policyId: string;
  productCode: string;
};

/**
 * Baixa o PDF da cotação empresarial. Se ainda não existir em `file_attachments`,
 * gera via POST /portal/v1/quotes/:policyId/pdf (`stage=quote`) e persiste no S3.
 */
export function useDownloadBusinessQuotePdf() {
  const queryClient = useQueryClient();

  return useMutation<GetProposalPdfResponse, Error, Variables>({
    mutationKey: ['quotes', 'download-quote-pdf'],
    mutationFn: async ({ policyId, productCode }) => {
      const existing = await businessQuotesService.getDocument(
        policyId,
        'quote'
      );

      if (existing.success && existing.data?.url) {
        return existing.data;
      }

      const generated = await homeownerQuotesService.getProposalPdf({
        policyId,
        productCode,
        stage: 'quote',
      });

      if (!generated.success || !generated.data) {
        throw new Error(generated.error || 'Erro ao gerar PDF da cotação');
      }

      return generated.data;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['quote-document', variables.policyId, 'quote'],
      });
    },
  });
}
